import {Modal} from "antd";
import styled from "styled-components";

interface ICallDetailsModalProps {
  title: string;
  visibleState: boolean;
  centered?: boolean;
  okFunc: () => void;
  cancelFunc: () => void;
  footerContent?: React.ReactNode[] | null;
  children: React.ReactNode;
  width?: number;
  closable?: boolean;
}

const StyledModalWrapper = styled.div`
  .ant-modal-body {
    border-radius: 50px !important;
  }
  .ant-modal-content {
    border-radius: 50px !important;
  }
`;

const CustomModal: React.FC<ICallDetailsModalProps> = ({
  title,
  visibleState,
  okFunc,
  cancelFunc,
  footerContent,
  width,
  children,
  closable = true,
  centered,
}) => {
  return (
    <StyledModalWrapper>
      <Modal
        visible={visibleState}
        zIndex={100}
        title={title}
        onOk={okFunc}
        onCancel={cancelFunc}
        footer={footerContent}
        closable={closable}
        centered={centered}
        width="90%"
        style={{borderRadius: 12, maxWidth: width || 600}}
      >
        {children}
      </Modal>
    </StyledModalWrapper>
  );
};

export {CustomModal};
